export default __webpack_public_path__ + "static/noissue101-background-top-c52c579244a07aa4bf986530b0d6562e.svg";